module.exports = "/_next/static/images/66112e3f12a17a0c19d0ba0f4d35e7c9-kit-icon.png";